import script from "./AvatarEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvatarEditor.vue?vue&type=script&lang=ts&setup=true"

import "./AvatarEditor.vue?vue&type=style&index=0&id=4381542d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4381542d"]])

export default __exports__